import { Injector } from '../Injector'

/**
 * Decorator to automatically provide the target class to the root injector.
 * @param singleton - Should the target be provided as a singleton?
 */
export function Injectable(singleton: boolean = true) {
	return function <T extends Constructor<any>>(target: T) {
		Injector.root.provide(target, { constructor: target }, singleton)
		return target
	}
}